import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { Link } from 'react-router-dom';
import {
    Navbar, Nav, NavDropdown,
    ToastContainer, Toast,
    Offcanvas
} from "react-bootstrap";
import { useSelector } from 'react-redux';
import {useLocation,useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Sidebar } from '../Sidebar/Sidebar';

import { logout } from '../../helpers/utilities';
import { getAppData } from '../../app/environment/environmentSlice';

import logo from '../../assests/aep-logo-white.svg';
import '../../helpers/fontawesomeLibrary';
import './styles.css';

export default function Header() {
    const appData = useSelector(getAppData);
    const [userIcon, setUserIcon] = useState('user');
    const [userRole, setUserRole] = useState('');
    const navigate= useNavigate();
    useEffect(() => {
        const { scope } = appData;
        switch(scope) {
            case 'doris-sandbox-read-only':
            case 'doris-dev-read-only':
            case 'doris-test-read-only':
            case 'doris-read-only':
                setUserRole('User');
            break;
            case 'doris-sandbox-support-only':
            case 'doris-dev-support-only':
            case 'doris-test-support-only':
            case 'doris-support-only':
                setUserRole('Support');
            break;
            case 'doris-sandbox-bu-admin':
            case 'doris-dev-bu-admin':
            case 'doris-test-bu-admin':
            case 'doris-bu-admin':
                setUserRole('Admin');
            break;
            default:  setUserIcon('user'); setUserRole('User');
        }
    }, [appData]);
    const [isUserWantLogout, setIsUserWantLogout]=useState(false);
    const isLoggedIn = Cookies.get('isLoggedIn');
    const logingOut = ()=> {
        setIsUserWantLogout(true);
    }
    const onCloseToast = () => {
        logout(appData);
        setIsUserWantLogout(false);
    }
    return (
      <>
        <Navbar expand="sm" bg="doris-navbar" variant="light">
            <Nav className='me-auto'>
                <Nav.Item className="aep-nav-header-brand">
                    <Navbar.Brand as={Link} to="/">
                        <img
                            src={logo}
                            className='AEP-Logo---White'
                            alt="AEP Now logo"
                            width="100"
                            height="50"
                        />
                    </Navbar.Brand>
                </Nav.Item>
            </Nav>
            <Nav className='justify-content-end flex-grow-1'>
                <Nav.Item>
                    <Navbar.Brand className="text-center">
                        <div className="d-block d-md-none aep-nav-header-title doris-title pt-3">
                            DERMS
                        </div>
                        <div className="d-none d-md-block aep-nav-header-title doris-short-title pt-3">
                         Distributed Energy Resource Management Systems
                        </div>
                    </Navbar.Brand>   
                </Nav.Item>
            </Nav>
            <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-sm`} />
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-sm`}
              aria-labelledby={`offcanvasNavbarLabel-expand-sm`}
              placement="end"
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title id={`offcanvasNavbarLabel-expand-sm`}>
                    DERMS
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Nav className="justify-content-end flex-grow-1">
                        {
                            <div className="d-block d-sm-none">
                                <Sidebar isHeader />
                                <div className="m-2 border">
                                    <div className="text-center">
                                        User Role:
                                        &nbsp;
                                        {userRole}
                                    </div>
                                    <div className="text-center">
                                        <FontAwesomeIcon icon={['fas', 'right-from-bracket']} transform="shrink-4" size="lg" />
                                        &nbsp;
                                        Logout
                                    </div>
                                </div>
                            </div>
                        }
                        {
                            isLoggedIn && (
                                <NavDropdown
                                    align="end"
                                    title={
                                        <>
                                        <span className='fa-layers fa-fw fa-2x'>
                                            <FontAwesomeIcon icon={['fas', 'circle']} inverse size="lg" />
                                            <FontAwesomeIcon icon={['fas', userIcon]} transform="shrink-4" />
                                        </span>
                                        </>
                                        
                                    }
                                    className="aep d-none d-sm-block"
                                    aria-label="User Dropdown"
                                >
                                    <NavDropdown.ItemText>
                                        <span className="text-center">
                                            User Role:
                                            &nbsp;
                                            {userRole}
                                        </span>
                                    </NavDropdown.ItemText>
                                    <NavDropdown.Divider />
                                    <NavDropdown.Item title="logout" aria-label="logout" onClick={() => { logingOut(); }}>
                                        <span>
                                            <FontAwesomeIcon icon={['fas', 'right-from-bracket']} transform="shrink-4" size="lg" />
                                            &nbsp;
                                            Logout
                                        </span>
                                    </NavDropdown.Item>
                                </NavDropdown>
                            )
                        }
                    </Nav>
                </Offcanvas.Body>
            </Navbar.Offcanvas>
        </Navbar>
        <ToastContainer aria-label="Logout Toast" className="p-3 mt-5" position="middle-center">
          <Toast
            bg="success"
            animation
            delay={5000}
            autohide
            onClose={onCloseToast}
            show={isUserWantLogout}
          >
            <Toast.Header closeButton={false}>
                <strong className='m-auto'>You are succesfully logged-out from DERMS!</strong>
            </Toast.Header>
            <Toast.Body>
                <div className='text-center fst-normal text-light'>Redirecting to login page</div>
            </Toast.Body>
          </Toast>
        </ToastContainer>
      </>
    );
}
